// ============================================
// ACHH WEBSITE CONTENT
// Edit all text content, images, and data here
// ============================================

const siteContent = {
  // ============================================
  // SITE CONFIGURATION
  // ============================================
  config: {
    siteName: "ACHH",
    siteFullName: "The African Cultural Heritage Hub",
     logoUrl: "/images/logo.png",
     showFullName: true,
    paypalEmail: "websesame@gmail.com", // UPDATE THIS with your PayPal email
    contactEmail: "tachhubb@gmail.com",
    contactPhone: "(470) 979-4694",
  },

  // ============================================
  // NAVIGATION MENU
  // ============================================
  navigation: {
    links: [
      { label: "Home", href: "#home" },
      { label: "About", href: "#about" },
      { label: "Activities", href: "#activities" },
      { label: "Publications", href: "#publications" },
      { label: "Donate", href: "#donate" },
    ],
  },

  // ============================================
  // HERO SECTION
  // ============================================
  hero: {
    title: {
      line1: "African Cultural",
      line2: "Heritage Hub",
    },
    subtitle: "Preserving the Past • Celebrating the Present • Inspiring the Future",
    buttons: {
      primary: {
        text: "Explore Activities",
        link: "#activities",
      },
      secondary: {
        text: "Support Our Mission",
        link: "#donate",
      },
    },
  },

  // ============================================
  // ABOUT SECTION
  // ============================================
  about: {
    title: "Our Mission",
    paragraphs: [
      "Preserving African Cultural Heritage for a Global Generation",
      "The African Cultural Heritage Hub (ACHH) is a nonprofit organization dedicated to preserving and promoting African cultural heritage through storytelling, traditional arts, music, dance, documentaries, and youth programs. We provide cultural education experiences that connect African folklore, history, and artistic traditions with communities across the diaspora and beyond.",
      "Through workshops, heritage tours, publications, and community events, ACHH empowers young people and families to engage deeply with Africa’s rich cultural legacy. Join us in sustaining African storytelling, safeguarding ancestral knowledge, and ensuring African traditions remain vibrant, accessible, and celebrated worldwide.",
    ],
    stats: [
      {
        number: "3+",
        label: "Years of Impact",
        icon: "/images/icons/calendar.png",  // ⭐ Add your icon
      },
      {
        number: "5000+",
        label: "Community Reach",
        icon: "/images/icons/people.png",  // ⭐ Add your icon
      },
      {
        number: "10+",
        label: "Programs + Projects Annually",
        icon: "/images/icons/programs.png",  // ⭐ Add your ico
      },
    ],
  },
  //============
  contact: {
  title: "Get in Touch",
  subtitle: "Have questions? Want to get involved? We'd love to hear from you!",
  email: "tachhubb@gmail.com",
  phone: "(470) 979-4694",
  address: "Atlanta, GA 30324",
},

  // ============================================
  // ACTIVITIES SECTION
  // ============================================
  activities: {
    title: "Get Involved",
    subtitle: "Join us in celebrating and preserving African cultural heritage",
    items: [
      {
        icon: "🎨",
        title: "Cultural Workshops",
        description: "Join hands-on workshops in traditional crafts, drumming, dance, and storytelling led by master artisans and cultural practitioners.",
        imageUrl: "/images/activities/workshops.jpg",  // ⭐ ADD THIS
      },
      {
        icon: "🗺️",
        title: "Heritage Tours",
        description: "Explore African cultural landmarks and historic sites through guided tours that bring history to life.",
        imageUrl: "/images/activities/tours.jpg",  // ⭐ ADD THIS
      },
      {
        icon: "🌱",
        title: "Youth Programs",
        description: "Empowering the next generation through education, mentorship, and cultural immersion programs.",
        imageUrl: "/images/activities/youth.jpg",  // ⭐ ADD THIS
      },
      {
        icon: "🎭",
        title: "Community Events",
        description: "Celebrate African culture through festivals, performances, exhibitions, and communal gatherings throughout the year.",
        imageUrl: "/images/activities/events.jpg",  // ⭐ ADD THIS
      },
    ],
  },

  // ============================================
  // PUBLICATIONS SECTION
  // ============================================
  publications: {
    title: "Our Publications",
    subtitle: "Explore our collection of books, music, folktales, and educational videos",
    // ========== DVDS (3) ==========
    dvds: [
      {
        title: "Legends & Legacy Part 1 : The Soul of African Storytelling",
        description: "A captivating exploration of Africa's rich folkloric heritage. The film delves into the cultural significance of oral traditions and tracks the evolution of African storytelling—from creation myths and animal fables to trickster tales and heroic legends.Running Time:60mins",
        price: "14.99",
        imageUrl: "/images/lal1.jpg",
        youtubeId: "S_olBF_uWog",
        stripeLink: "https://buy.stripe.com/7sY5kC4dI9Vn2t53kDeQM00",  // ⭐ REPLACE with your Stripe payment link
      },
      {
        title: "Legends and Legacy Part 2: The Magic of African Storytelling Traditions",
        description: "Explores the rich heritage of African folktales, revealing how timeless stories preserve history, teach values, and celebrate culture through powerful narration and vivid imagery. Running Time: 60mins",
        price: "14.99",
        imageUrl: "/images/lal2.jpg",
        youtubeId: "gORMb6wW3mU",
        stripeLink: "https://buy.stripe.com/6oU14mh0u1oRebN9J1eQM01",  // ⭐ REPLACE with your Stripe payment link
      },
      {
        title: "The Storyland Train",
        description: "Delivers captivating tales from many cultures. This enchanting eleven-story collection ignites imagination and wonder—perfect for curious minds and shared family moments! Running Time:60mins",
        price: "14.99",
        imageUrl: "/images/storytrain.jpg",
        youtubeId: "Z5JDV2hcuDs",
        stripeLink: "https://buy.stripe.com/fZu9ASaC63wZebNcVdeQM02",  // ⭐ REPLACE with your Stripe payment link
      },
    ],
     // ========== FOLKTALE CDS (3) ==========
    folktaleCDs: [
      {
        title: "Folktales of Africa 1",
       // artist: "[NARRATOR/STORYTELLER NAME 1]",
        description: "Brings together fifteen treasured African folk stories filled with wisdom, humor, and life lessons. Rooted in oral tradition, these stories explore courage, kindness, perseverance, and community, preserving the spirit of African storytelling for readers of all ages.",
        price: "12.99",
        imageUrl: "/images/foa1.jpg",
        audioSample: "/samples/lazy-soule.mp3",
        stripeLink: "https://buy.stripe.com/aFacN4eSm9Vn2t53kDeQM03",  // ⭐ REPLACE with your Stripe payment link
      },
      {
        title: "Folktales of Africa 2",
       // artist: "[NARRATOR/STORYTELLER NAME 2]",
        description: "Fifteen compelling folktales reveal the heart of African cultural heritage. Through memorable characters and meaningful journeys, this collection shares moral guidance, ancestral wisdom, and timeless truths that continue to shape values across generations.",
        price: "12.99",
        imageUrl: "/images/foa2.jpg",
        audioSample: "/samples/lazy-soule.mp3",
        stripeLink: "https://buy.stripe.com/aFa4gy6lQ3wZ1p1f3leQM04",  // ⭐ REPLACE with your Stripe payment link
      },
      {
        title: "Folktales of Africa 3",
       // artist: "[NARRATOR/STORYTELLER NAME 3]",
        description: "Features fifteen vibrant folktales that spark imagination and celebrate the power of story. Filled with drama, insight, and unforgettable moments, this collection honors Africa’s rich storytelling legacy while inspiring readers to reflect, dream, and grow",
        price: "12.99",
        imageUrl: "/images/foa3.jpg",
        audioSample: "/samples/lazy-soule.mp3",
        stripeLink: "https://buy.stripe.com/8x2eVc6lQgjL4BdbR9eQM05",  // ⭐ REPLACE with your Stripe payment link
      },
    ],

    // ========== MUSIC CDS (2) ==========
    musicCDs: [
      {
        title: "Songs of My Country",
        artist: "Cactus Town Crew + Lyrics by Rotimi Ogunjobi",
        description: "These songs address governance, survival, faith, identity, memory, and responsibility—not as abstract themes, but as daily realities in Nigeria. The nation appears here not as an idea, but as a place where people queue, wait, hope, hustle, pray, adapt, and endure. The voice in these songs is of the witness—observant, concerned, occasionally weary, but never detached.",
        price: "12.99",
        imageUrl: "/images/somc.jpg",
        audioSample: "/samples/stomach-infrastructure.mp3",
        stripeLink: "https://buy.stripe.com/eVq7sKcKeebDaZBdZheQM06",  // ⭐ REPLACE with your Stripe payment link
      },
      
    ],
    // ========== BOOKS (3) ==========
    books: [
      {
        title: "When the Sun Sleeps",
       // author: "[AUTHOR NAME 1]",
        description: "From the tales of magic and superhuman prowess of Egypt to the highly believable anthropomorphic tales told across the continent to Southern Africa, these stories demonstrate the culture, traditions, beliefs, fantasies, and aspirations of the many nations. They also reflect on the evolution of the folktale - how a tale thought to come from a specific community appears in the folklore of another, several thousand miles away, with localized characters, and it becomes impossible to determine the true origin of the story.ALSO AVAILABLE ON KINDLE",
        price: "14.45",
        imageUrl: "/images/sunsleeps.jpg",
        pdfSample: "/samples/sunsleeps.pdf",
        stripeLink: "https://buy.stripe.com/28E00ieSm2sV7Np4oHeQM07",  // ⭐ REPLACE with your Stripe payment link
      },
      {
        title: "I Dead : The Quiet Afterlife of Ezekiel Roots",
       // author: "",
        description: "Ezekiel “Zek” Roots dies calmly—just as he lived.He does not wake up in heaven or hell. He wakes up standing, in a quiet afterlife that offers no judgment, no explanations, and no easy answers.I Dead is a quietly comic, metaphysical novella about responsibility, courage, and the danger of mistaking calm for wisdom. With restrained humor and philosophical bite, it asks not what happens after death—but what we postpone while alive, and what it costs to stop waiting.ALSO AVAILABLE ON KINDLE",
        price: "9.95",
        imageUrl: "/images/idead.jpg",
        pdfSample: "/samples/idead.pdf",
        stripeLink: "https://buy.stripe.com/cNibJ0aC65F78Rt5sLeQM08",  // ⭐ REPLACE with your Stripe payment link
      },
      {
        title: "Janko's Republic",
      //  author: "[AUTHOR NAME 3]",
        description: "In the fictional African country of Kingsland, a ragtag group of undereducated rebel soldiers known as the People’s Sovereign Brigade stages a coup to unseat a corrupt civilian government. Promising to free the people from the lingering grip of colonial oppression, they install their charismatic leader, Commander Janko, as the new head of state—and rename the country Janko Land.Janko’s Republic is a darkly humorous and sobering tale of how revolutions can devour themselves—and how the faces at the top may change, but the game often stays the same. ALSO AVAILABLE ON KINDLE",
        price: "9.95",
        imageUrl: "/images/janko.jpg",
        pdfSample: "/samples/janko.pdf",
        stripeLink: "https://buy.stripe.com/dRm14m11w6JbgjV9J1eQM09",  // ⭐ REPLACE with your Stripe payment link
      },
      {
       title: "African Folktales and Storytelling",
       /// author: "[AUTHOR NAME 3]",
        description: "At its core, African folklore embodies the soul of the continent, reflecting its diverse peoples, landscapes, and histories. This book delves into the rich landscape of African folklore, exploring its diverse cultures, traditions, and storytelling techniques. Through a combination of historical context and literary analysis, readers will gain a deeper understanding of the significance of folktales in African societies. ALSO AVAILABLE ON KINDLE",
        price: "19.95",
        imageUrl: "/images/storytelling.jpg",
        pdfSample: "/samples/storytelling.pdf",
        stripeLink: "https://buy.stripe.com/4gMcN48tYd7z1p18EXeQM0a",  // ⭐ REPLACE with your Stripe payment link
      },
{
        title: "The Story Cloud Children's Books 1 ",
       // author: "[AUTHOR NAME 3]",
        description: " 10 books set. Combines timeless tales from diverse cultures with educational snippets. This family-friendly series sparks imagination, curiosity, and a love for learning. A magical journey of storytelling and discovery, perfect for children and parents to enjoy together! AVAILABLE ON KINDLE https://a.co/d/00qxWK2L",
        price: "69.99",
        imageUrl: "/images/storycloud.jpg",
        pdfSample: "/samples/storycloud.pdf",
        stripeLink: "https://buy.stripe.com/cNi9ASeSmffHebN08reQM0b",  // ⭐ REPLACE with your Stripe payment link
        },
    ],
 },

  // ============================================
  // DONATE SECTION
  // ============================================
  donate: {
    title: "Support Our Mission",
    subtitle: "Your contribution helps preserve and celebrate African cultural heritage",
    infoTitle: "Why Your Support Matters",
    benefits: [
      "Fund educational programs and workshops for youth and communities",
      "Support artists, musicians, and cultural practitioners",
      "Preserve traditional knowledge and oral histories",
      "Create accessible cultural resources and publications",
    ],
    amountTitle: "Select an Amount",
    amounts: ["$25", "$50", "$100", "$250", "$500", "Custom"],
    buttonText: "Donate Now via PayPal",
    taxNote: "The African Cultural Heritage Hub is a NOT a 501(c)(3) nonprofit organization. Your donation is NOT tax-deductible.",
  },

  // ============================================
  // FOOTER
  // ============================================
  footer: {
    sections: [
      {
        title: "The African Cultural Heritage Hub",
        content: "Preserving traditions, inspiring futures.",
      },
      {
        title: "Quick Links",
        links: [
          { text: "About Us", href: "#about" },
          { text: "Activities", href: "#activities" },
          { text: "Publications", href: "#publications" },
          { text: "Donate", href: "#donate" },
        ],
      },
      {
        title: "Contact",
        lines: [
          "Email: tachhubb@gmail.com",
          "Phone: (470) 979-4694",
          "Director: Rotimi Ogunjobi",
        ],
      },
    ],
    copyright: "© 2026 African Cultural Heritage Hub.Registered as a charitable organization in the state of Georgia, USA. Registration CH018047. All rights reserved.",
  },
};

export default siteContent;
